export interface InfoTextProps {
  /** Paragraphs, separated by blank lines — the shape the Vue tooltips used. */
  text: string;
}

/** An explanation of a metric, as the body of an `InfoTip`. */
export function InfoText({ text }: InfoTextProps) {
  return (
    <span className='flex flex-col gap-2 text-left'>
      {text.split('\n\n').map((paragraph) => (
        <span key={paragraph}>{paragraph}</span>
      ))}
    </span>
  );
}
